import gql from "graphql-tag";
import { toGqlTypes, toGqlArgs, toGqlFields } from "../utils/string";

const fetchListPost = gql`
  query (
    $postId: ID
    $type: String
    $status: String
    $offset: Int
    $limit: Int
    $search: String
    $category: CatType
  ) {
    fetchListPost(
      postId: $postId
      type: $type
      status: $status
      offset: $offset
      limit: $limit
      search: $search
      category: $category
    ) {
      total
      totalPage
      data {
        postId
        postTitleTH
        postTitleEN
        subTitleTH
        subTitleEN
        descriptionTH
        descriptionEN
        orderNo
        status
        type
        date
        linkOriginal
        postBannerId
        postThumbnailId
        bannerLink
        thumbnailLink
        division
        readPost
        updatedAt
        category
        fileData {
          fileId
          fileMimeType
        }
      }
    }
  }
`;

const fetchListPostType = gql`
  query (
    $postId: ID
    $type: String
    $status: String
    $offset: Int
    $limit: Int
    $search: String
    $category: CatType
  ) {
    fetchListPost(
      postId: $postId
      type: $type
      status: $status
      offset: $offset
      limit: $limit
      search: $search
      category: $category
    ) {
      total
      totalPage
      data {
        postId
        postTitleTH
        subTitleTH
        descriptionTH
        type
        linkOriginal
        date
        bannerLink
        division
      }
    }
  }
`;

const fetchTimeAttendanceByDate = gql`
  query ($date: Date!, $sorting: SortingType!, $profileKey: String!) {
    timeAttendanceByDate(
      date: $date
      sorting: $sorting
      profileKey: $profileKey
    ) {
      date
      times {
        timeAttendanceId
        timestamp
      }
    }
  }
`;
const fetchProfile = gql`
  query {
    fetchProfile {
      isShowProfileHistory
      isPlasmaHr
      name
      nameEng
      personId
      title
      firstName
      lastName
      middleName
      titleEng
      firstNameEng
      lastNameEng
      middleNameEng
      militaryStatus
      gender
      birthDate
      identityCard
      identityCardIssueAt
      identityCardDate
      bloodGroups
      nationality
      race
      religion
      passportNo
      maritalStatus
      marryDate
      employeeCodes
      consent
      currentProfile
      divisionName
      isHr
      isKCMH
      isPlasma
      isSomdej
      agencyName
      isCanLeave
      isBC
      imageContent {
        image
        mimeType
      }
      isEmployeeApprover
      isEmployeeApproverLeave
      isEmployeeApproverWelfare
      isEmployeeManagement
      isTrial
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      posManageCode
      posManageName
      posTechnicalCode
      posTechnicalName
      positionCode
      positionName
      displayConfig {
        showLv
        lv1
        lv2
        lv3
        lv4
        lv5
        screenName
      }
    }
  }
`;

const fetchProfileForLeave = gql`
  query {
    fetchProfileForLeave {
      isShowProfileHistory
      isPlasmaHr
      empName
      personId
      title
      firstName
      lastName
      middleName
      titleEng
      firstNameEng
      lastNameEng
      middleNameEng
      militaryStatus
      gender
      birthDate
      identityCard
      identityCardIssueAt
      identityCardDate
      bloodGroups
      nationality
      race
      religion
      passportNo
      maritalStatus
      marryDate
      employeeCodes
      consent
      currentProfile
      division
      department
      isHr
      isKCMH
      isPlasma
      isSomdej
      agencyName
      isCanLeave
      isBC
      maritalStatusName
      militaryStatusName
      posManageCode
      posManageName
      posTechnicalCode
      posTechnicalName
      positionCode
      positionName
      imageContent {
        image
        mimeType
      }
      isEmployeeApprover
      isEmployeeApproverLeave
      isEmployeeManagement
      isTrial
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      posManageCode
      posManageName
      posTechnicalCode
      posTechnicalName
      positionCode
      positionName
      displayConfig {
        showLv
        lv1
        lv2
        lv3
        lv4
        lv5
        screenName
      }
      orgCode
      orgUnitCode
      organizationName
    }
  }
`;

const fetchProfileDetail = gql`
  query ($category: String) {
    fetchProfileDetail(category: $category) {
      title
      personId
      firstName
      lastName
      name
      nameEng
      titleEng
      firstNameEng
      lastNameEng
      birthDate
      gender
      height
      weight
      bloodGroups
      nationality
      provinceOfBirth
      religion
      address {
        addressId
        relatedId
        email1
        phone1
        mobilePhone
      }
    }
  }
`;

const fetchEmployeeProfile = gql`
  query {
    fetchEmployeeProfile {
      empCode
      hnNo
      licenseNo
      agency
      remark
      carpark
      carparkRemark
      hnNo_somdej
      refCarpark {
        id
        textTh
        textEn
        isDefault
      }
      refCode
      payWagesType
      benefits
      workingProfile {
        startDate
        endDate
        orgPosition {
          orgUnitId
          positionId
          positionCode
          positionName
          positionNameEng
        }
        orgUnit {
          orgId
          orgUnitTypeId
          orgUnitId
          orgUnitCode
          orgUnitName
          orgUnitNameEng
          parentOrgUnit
        }
        empLevel {
          emplLevelCode
          empLevelName
          emplLevelName
        }
      }
      address {
        addressId
        addressNo
        addressName
        groupNo
        building
        roomNo
        floorNo
        vilage
        lane
        street
        district
        amphur
        province
        postalCode
        country
        contactName
        mobilePhone
        phone1
        phone2
        phone3
        fax
        email1
        email2
        email3
      }
      workingStatus
    }
  }
`;

const fetchSlip = gql`
  query (
    $month: String!
    $year: String!
    $identityCard: String!
    $profileKey: String!
  ) {
    fetchSlip(
      month: $month
      year: $year
      identityCard: $identityCard
      profileKey: $profileKey
    ) {
      paymentDate
      income {
        lists {
          name
          value
        }
        total
        totalPerMonth
        totalPerYear
      }
      expense {
        total
        withholdingTax
        lists {
          name
          value
        }
      }
      baseTax406
    }
  }
`;

const fetchSlipPayDate = gql`
  query (
    $month: String!
    $year: String!
    $identityCard: String!
    $profileKey: String!
  ) {
    fetchSlipPayDate(
      month: $month
      year: $year
      identityCard: $identityCard
      profileKey: $profileKey
    ) {
      payDate
    }
  }
`;

const fetchUrlSlip = gql`
  query (
    $month: String!
    $year: String!
    $identityCard: String!
    $profileKey: String!
  ) {
    fetchUrlSlip(
      month: $month
      year: $year
      identityCard: $identityCard
      profileKey: $profileKey
    ) {
      linkPDF
    }
  }
`;

const fetchListContactUs = gql`
  query (
    $contactUsId: ID
    $contactUsCategoryId: ID
    $status: String
    $search: String
  ) {
    fetchListContactUs(
      contactUsId: $contactUsId
      contactUsCategoryId: $contactUsCategoryId
      status: $status
      search: $search
    ) {
      contactUsId
      contactUsTitle
      contactUsLinkWebSite
      contactUsTel
      contactUsFax
      contactUsAdress
      contactUsExtraTel
      contactUsCategoryId
      contactUsCategoryName
      leaderName
      leaderEmail
      position
      telNoExtra
      contactUsTelDivision {
        contactUsTelDivisionId
        email
        name
        divisionName
        telNo
        position
        telNoExtra
      }
    }
  }
`;

const fetchListDocumenList = gql`
  query (
    $docId: ID
    $docGroupId: String
    $search: String
    $offset: Int
    $limit: Int
  ) {
    fetchListDocument(
      docId: $docId
      docGroupId: $docGroupId
      search: $search
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        docId
        fileId
        linkFile
        docTitle
        docDescription
        systemId
        docIcon
        docGroupId
        orderNo
        status
        activeDate
        createdAt
        updatedAt
        division
      }
    }
  }
`;

const fetchListDocumen = gql`
  query (
    $docId: ID
    $docGroupId: String
    $search: String
    $offset: Int
    $limit: Int
  ) {
    fetchListDocument(
      docId: $docId
      docGroupId: $docGroupId
      search: $search
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        docId
        fileId
        linkFile
        docTitle
        docDescription
        systemId
        docIcon
        docGroupId
        orderNo
        status
        activeDate
        createdAt
        updatedAt
        division
        fileData {
          fileId
          fileMimeType
        }
      }
    }
  }
`;

const refreshToken = `
  query($token: String,$refreshToken: String){
    refreshToken(
        token:$token
        refreshToken:$refreshToken
    ){
      accessToken
    }
  }
`;

const verifyUser = gql`
  query (
    $lsid: ID!
    $verificationCode: String!
    $citizenId: String!
    $birthDate: Date!
    $organization: String!
  ) {
    verifyUser(
      lsid: $lsid
      verificationCode: $verificationCode
      citizenId: $citizenId
      birthDate: $birthDate
      organization: $organization
    ) {
      personId
      firstName
      middleName
      lastName
      firstNameEng
      middleNameEng
      lastNameEng
      gender
      employee {
        workingProfile {
          orgPosition {
            positionName
          }
          orgUnit {
            orgUnitName
          }
        }
      }
    }
  }
`;

const fetchListOrganization = gql`
  query ($orgId: ID, $orgGroupId: String, $status: String, $order: String) {
    fetchListOrganization(
      orgId: $orgId
      orgGroupId: $orgGroupId
      status: $status
      order: $order
    ) {
      orgId
      orgTitle
      orgGroupId
      descriotion
      orderNo
      status
      linkOriginal
      createdAt
      updatedAt
      postBannerId
      postThumbnailId
      bannerLink
      thumbnailLink
    }
  }
`;

const fetchEmployeeBankAccount = gql`
  query {
    fetchEmployeeBankAccount {
      bookName
      bookNo
      percentageSend
      bankId
      bankBranchId
      bank {
        bankId
        bankCode
        bankName
        bankNameEng
        bankShortName
      }
      bankBranch {
        bankBranchId
        bankId
        bankBranchType
        bankBranchCode
        bankBranchName
        bankBranchNameEng
        remark
      }
    }
  }
`;

const fetchEmployeeTax = gql`
  query {
    fetchEmployeeTax {
      taxReduceId
      spouseDivide
      spouseReduce
      childStudy
      childNotStudy
      insuraAmount
      spouseInsuraAmnt
      donationCharity
      DonationEducate
      interestLoan
      rmfDeposit
      ssfDeposit
      compensationLaw
      gpfDeposit
      assistInstructor
      nameFather
      fatherTitle
      fatherFname
      fatherMname
      fatherLname
      fatherIdentNo
      fatherReduAmnt
      nameMother
      motherTitle
      motherFname
      motherMname
      motherLname
      motherIdentNo
      motherReduAmnt
      nameSpouFather
      spouFatherTitle
      spouFatherFname
      spouFatherMname
      spouFatherLname
      spouFatherIdentNo
      spouFatherReduAmnt
      nameSpouMother
      spouMotherTitle
      spouMotherFname
      spouMotherMname
      spouMotherLname
      spouMotherIdentNo
      spouMotherReduAmnt
      fatherHealthInsurance
      matherHealthInsurance
      spouFaHealthInsurance
      spouMaHealthInsurance
      isAdopterChildStudy
      isAdopterChildNoStudy
      supportSport
      property
      fixCarFlood
      fixFloodHome
      firstHome
      longInsurance
      isTwoBenefits
      reduceOther1
      reduceOther2
      reduceOther3
      reduceOther4
      reduceOther5
      reduceDomesticTourismTax
      reduceTravelProductsServicesTax
      reduceShopping
      reduceOTOP
      reduceTravelDecember
      HealthInsurance
      childFrom2018
      reducePregnancy
      SecondaryTourist
      donationHospital
      reduceTire
      reduceBook
      totalReduce
      childAllTotal
      childStudyTotal
    }
  }
`;

const fetchEmployeeCompensation = gql`
  query {
    fetchEmployeeCompensation {
      income {
        compensationLineId
        listNo
        incomeDeductId
        incomeDeductAmount
        incomeDeductType
        startDate
        endDate
        remark
        paymentType
        paymentPeriod
        calcIncStartPeriod
        isCancel
        isCancelAlert
        incomeDeduct {
          incomeDeductId
          incomeDeductCode
          incomeDeductName
          taxName
          calcMethod
        }
      }
      deduct {
        compensationLineId
        listNo
        incomeDeductId
        incomeDeductAmount
        incomeDeductType
        startDate
        endDate
        remark
        paymentType
        paymentPeriod
        calcIncStartPeriod
        isCancel
        isCancelAlert
        incomeDeduct {
          incomeDeductId
          incomeDeductCode
          incomeDeductName
          taxName
          calcMethod
        }
      }
    }
  }
`;

const fetchListNotification = gql`
  query ($notificationGroup: NotificationGroup!, $offset: Int, $limit: Int) {
    fetchListNotification(
      notificationGroup: $notificationGroup
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      totalNotification
      data {
        notificationId
        title
        body
        postId
        docId
        courseId
        createdAt
        read
        isConfirm
        confirm
        division
        notiFrom
        redirectPath
      }
    }
  }
`;

const verifyEmpCodeLogin = gql`
  query (
    $empCode: String!
    $captchaText: String
    $captchaUid: String
    $organization: ID!
    $csId: String!
    $workflow: SignInWorkflow!
  ) {
    verifyEmpCodeLogin(
      empCode: $empCode
      captchaText: $captchaText
      captchaUid: $captchaUid
      organization: $organization
      csId: $csId
      workflow: $workflow
    ) {
      lsid
      exp
      stat
      form
    }
  }
`;

const fetchPolicyLastVersion = gql`
  query {
    fetchPolicyLastVersion {
      policyId
      desciption
      version
    }
  }
`;

const generateCaptcha = gql`
  query {
    generateCaptcha {
      captchaSvg
      captchaUid
      exp
    }
  }
`;

const domainLists = gql`
  query {
    domainLists {
      id
      value
      prefix
      textTh
      textEn
    }
  }
`;

const accordingProfile = gql`
  query {
    accordingProfile {
      profileKey
      empCode
      workProfile {
        organization {
          orgName
          orgNameEng
        }
        orgUnit {
          orgUnitName
          orgUnitNameEng
        }
        orgPosition {
          positionName
          positionNameEng
        }
      }
    }
  }
`;

const fetchCourse = gql`
  query (
    $courseId: ID
    $search: String
    $courseCategory: CourseCategory
    $offset: Int
    $limit: Int
  ) {
    fetchCourse(
      courseId: $courseId
      search: $search
      courseCategory: $courseCategory
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        courseId
        title
        subTitle
        description
        startDate
        endDate
        orderNo
        link
        fileId
        status
        linkFile
        linkImage
        courseCategory
        createdAt
        updatedAt
        fileData {
          fileId
          fileMimeType
        }
        fileDocumentData {
          fileId
          fileMimeType
        }
      }
    }
  }
`;

const fetchCourseList = gql`
  query (
    $courseId: ID
    $search: String
    $courseCategory: CourseCategory
    $offset: Int
    $limit: Int
  ) {
    fetchCourse(
      courseId: $courseId
      search: $search
      courseCategory: $courseCategory
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        courseId
        title
        subTitle
        description
        startDate
        endDate
        orderNo
        type
        link
        fileId
        status
        linkFile
        linkImage
        courseCategory
        createdAt
        updatedAt
        fileData {
          fileId
          fileMimeType
        }
      }
    }
  }
`;

const fetchListOrganizationGroup = gql`
  query ($status: String, $order: String) {
    fetchListOrganizationGroup(status: $status, order: $order) {
      orgGroupId
      orgGroupTitle
      descriotion
      orderNo
      status
      linkOriginal
      createdAt
      updatedAt
    }
  }
`;

const fetchEmployeeFamily = gql`
  query {
    fetchEmployeeFamily {
      familyId
      isEmergencyCon
      title
      firstName
      lastName
      identityCard
      gender
      birthDate
      relationship
      relationshipText
      hnNo
      childNo
      benefits
      hnNo_Somdej
      personStatus
      deathDate
      refPrefix {
        textTh
        textEn
        id
      }
    }
  }
`;

const fetchEmployeeRights = gql`
  query {
    fetchProfile {
      name
      nameEng
      personId
      title
      firstName
      lastName
      middleName
      titleEng
      firstNameEng
      lastNameEng
      middleNameEng
      militaryStatus
      gender
      birthDate
      identityCard
      identityCardIssueAt
      identityCardDate
      bloodGroups
      nationality
      race
      religion
      passportNo
      maritalStatus
      marryDate
      employeeCodes
      consent
      currentProfile
      divisionName
      isHr
      isKCMH
    }
    fetchEmployeeProfile {
      empCode
      hnNo
      licenseNo
      agency
      remark
      carpark
      carparkRemark
      hnNo_somdej
      refCarpark {
        id
        textTh
        textEn
        isDefault
      }
      refCode
      payWagesType
      benefits
      workingProfile {
        startDate
        endDate
        orgPosition {
          orgUnitId
          positionId
          positionCode
          positionName
          positionNameEng
        }
        orgUnit {
          orgId
          orgUnitTypeId
          orgUnitId
          orgUnitCode
          orgUnitName
          orgUnitNameEng
          parentOrgUnit
        }
        positionManage {
          posManageName
        }
        positionTechnical {
          posTechnicalName
        }
        empLevel {
          emplLevelCode
          empLevelName
          emplLevelName
        }
      }
      address {
        addressId
        addressNo
        addressName
        groupNo
        building
        roomNo
        floorNo
        vilage
        lane
        street
        district
        amphur
        province
        postalCode
        country
        contactName
        mobilePhone
        phone1
        phone2
        phone3
        fax
        email1
        email2
        email3
      }
      workingStatus
      employDate
      licenseExpirationDate
    }
    fetchEmployeeFamily {
      familyId
      isEmergencyCon
      title
      firstName
      lastName
      identityCard
      gender
      birthDate
      relationship
      relationshipText
      hnNo
      childNo
      benefits
      hnNo_Somdej
      personStatus
      deathDate
      refPrefix {
        textTh
        textEn
        id
      }
    }
  }
`;

const fetchEmployeeProvidentFund = gql`
  query {
    fetchEmployeeProvidentFund {
      accMemberCode
      provStartDate
      provEndDate
      provEmployerDeduct
      provEmployeeDeduct
      isMember
      isDeduct
      memberStatus
      providentFund {
        providentFundID
        providentFundCode
        providentFundName
        providentFundNameEng
        providentFundShortName
      }
    }
  }
`;

const howToOpenPayrollSlip = gql`
  query {
    howToOpenPayrollSlip
  }
`;

const fetchUrlTax = gql`
  query (
    $month: String!
    $year: String!
    $identityCard: String!
    $profileKey: String!
  ) {
    fetchUrlTax(
      month: $month
      year: $year
      identityCard: $identityCard
      profileKey: $profileKey
    ) {
      linkPDF
    }
  }
`;

const checkRequestCaptcha = gql`
  query ($csId: String!) {
    checkRequestCaptcha(csId: $csId)
  }
`;

const requestSendingOTP = gql`
  query ($telNo: String!) {
    requestSendingOTP(telNo: $telNo) {
      otpToken
      refCode
      startTime
      endTime
      text
      expiredAt
    }
  }
`;

const sendVerifyCode = gql`
  query (
    $requestFor: RequestFor!
    $sendMethod: ReceiveChannel!
    $citizenId: String!
    $birthDate: Date!
    $empCode: String!
    $organization: String!
  ) {
    sendVerifyCode(
      requestFor: $requestFor
      sendMethod: $sendMethod
      citizenId: $citizenId
      birthDate: $birthDate
      empCode: $empCode
      organization: $organization
    ) {
      text
      startTime
      endTime
    }
  }
`;

const setupPassword = gql`
  query (
    $lsid: ID!
    $verificationCode: String!
    $citizenId: String!
    $birthDate: Date!
    $password: String!
    $confirmPassword: String!
    $policyId: ID
    $organization: String!
  ) {
    setupPassword(
      lsid: $lsid
      verificationCode: $verificationCode
      citizenId: $citizenId
      birthDate: $birthDate
      password: $password
      confirmPassword: $confirmPassword
      policyId: $policyId
      organization: $organization
    ) {
      status
    }
  }
`;

const forgetPassword = gql`
  query (
    $lsid: ID!
    $identityCard: String!
    $birthDate: Date!
    $organization: String!
    $requestFor: RequestFor!
  ) {
    forgetPassword(
      lsid: $lsid
      identityCard: $identityCard
      birthDate: $birthDate
      organization: $organization
      requestFor: $requestFor
    ) {
      status
    }
  }
`;

const checkSMSforgetPassword = gql`
  query (
    $lsid: ID!
    $identityCard: String!
    $birthDate: Date!
    $organization: String!
    $verificationCode: String!
  ) {
    checkSMSforgetPassword(
      lsid: $lsid
      identityCard: $identityCard
      birthDate: $birthDate
      organization: $organization
      verificationCode: $verificationCode
    ) {
      personId
      firstName
      middleName
      lastName
      firstNameEng
      middleNameEng
      lastNameEng
      gender
      employee {
        workingProfile {
          orgPosition {
            positionName
          }
          orgUnit {
            orgUnitName
          }
        }
      }
    }
  }
`;

const resetPassword = gql`
  query (
    $lsid: ID!
    $identityCard: String!
    $verificationCode: String!
    $birthDate: Date!
    $organization: String!
    $password: String!
    $confirmPassword: String!
  ) {
    resetPassword(
      lsid: $lsid
      identityCard: $identityCard
      verificationCode: $verificationCode
      birthDate: $birthDate
      organization: $organization
      password: $password
      confirmPassword: $confirmPassword
    ) {
      status
    }
  }
`;

const requestProfileCheck = gql`
  query (
    $lsid: ID!
    $requestFor: RequestFor!
    $verificationCode: String
    $citizenId: String!
    $birthDate: Date!
    $organization: String!
  ) {
    requestProfileCheck(
      lsid: $lsid
      requestFor: $requestFor
      verificationCode: $verificationCode
      citizenId: $citizenId
      birthDate: $birthDate
      organization: $organization
    ) {
      status
    }
  }
`;

const fetchListDocumentGroup = gql`
  query ($docGroupCode: docGroupCode, $order: String, $search: String) {
    fetchListDocumentGroup(
      docGroupCode: $docGroupCode
      order: $order
      search: $search
    ) {
      docGroupId
      docGroupTitle
      docGroupCode
      orderNo
      createdAt
      updatedAt
    }
  }
`;

const fetchListSystem = gql`
  query {
    fetchListSystem {
      id
      code
      name
      nameEn
      refId
      isActive
      createdAt
      updatedAt
    }
  }
`;

const fetchListContactUsCategory = gql`
  query ($contactUsCategoryId: ID) {
    fetchListContactUsCategory(contactUsCategoryId: $contactUsCategoryId) {
      contactUsCategoryId
      contactUsCategoryName
      orderNo
    }
  }
`;

const templateFormTax = gql`
  query {
    templateFormTax {
      name
      conditions
      keyForm
      disableTitle
      border
      borderTop
      descriptions
      alertText
      keyName
      input {
        label
        name
        type
        subTitle
        min
        max
        disable
        radioChoices {
          label
          value
        }
      }
    }
  }
`;

const fetchTaxDraft = gql`
  query ($month: Int!, $year: Int!) {
    fetchTaxDraft(month: $month, year: $year) {
      taxDraftId
      childBirthBefore2561
      childBirthAfter2561
      adoptedChild
      isSponserFather
      isFatherHealthInsurance
      isSponserMother
      isMotherHealthInsurance
      isSponserSpouFather
      spouFatherFname
      spouFatherLname
      spouFatherIdentNo
      spouFatherReduAmnt
      fatherHealthInsurance
      isSpouFatherHealthInsurance
      spouFaHealthInsurance
      isSponserSpouMother
      spouMotherFname
      spouMotherLname
      spouMotherIdentNo
      spouMotherReduAmnt
      matherHealthInsurance
      isSpouMotherHealthInsurance
      spouMaHealthInsurance
      isSponserDisabled
      isNumberOfDisabled
      employeeName1
      idCardDisabled1
      lessAllowance1
      relation1
      employeeName2
      idCardDisabled2
      lessAllowance2
      relation2
      employeeName3
      idCardDisabled3
      lessAllowance3
      relation3
      employeeName4
      idCardDisabled4
      lessAllowance4
      relation4
      employeeName5
      idCardDisabled5
      lessAllowance5
      relation5
      employeeName6
      idCardDisabled6
      lessAllowance6
      relation6
      employeeName7
      idCardDisabled7
      lessAllowance7
      relation7
      employeeName8
      idCardDisabled8
      lessAllowance8
      relation8
      employeeName9
      idCardDisabled9
      lessAllowance9
      relation9
      employeeName10
      idCardDisabled10
      lessAllowance10
      relation10
      insuraAmount
      rmfDeposit
      ssfDeposit
      interestLoan
      accumulateSocial
      donationEducate
      donationCharity
      month
      year
      updatedAt
      sendDate
      isDelete
      fatherTitle
      fatherFname
      fatherLname
      fatherIdentNo
      fatherReduAmnt
      motherTitle
      motherFname
      motherLname
      motherIdentNo
      motherReduAmnt
    }
  }
`;

const fetchDetailTaxAll = gql`
  query ($month: Int!, $year: Int!) {
    fetchProfile {
      maritalStatus
    }
    fetchEmployeeProfile {
      workingStatus
    }
    fetchEmployeeTax {
      taxReduceId
      spouseDivide
      spouseReduce
      childStudy
      childNotStudy
      insuraAmount
      spouseInsuraAmnt
      DonationCharity
      DonationEducate
      interestLoan
      rmfDeposit
      ssfDeposit
      compensationLaw
      gpfDeposit
      assistInstructor
      nameFather
      fatherTitle
      fatherFname
      fatherMname
      fatherLname
      fatherIdentNo
      fatherReduAmnt
      nameMother
      motherTitle
      motherFname
      motherMname
      motherLname
      motherIdentNo
      motherReduAmnt
      nameSpouFather
      spouFatherTitle
      spouFatherFname
      spouFatherMname
      spouFatherLname
      spouFatherIdentNo
      spouFatherReduAmnt
      nameSpouMother
      spouMotherTitle
      spouMotherFname
      spouMotherMname
      spouMotherLname
      spouMotherIdentNo
      spouMotherReduAmnt
      fatherHealthInsurance
      matherHealthInsurance
      spouFaHealthInsurance
      spouMaHealthInsurance
      isAdopterChildStudy
      isAdopterChildNoStudy
      supportSport
      property
      fixCarFlood
      fixFloodHome
      firstHome
      longInsurance
      isTwoBenefits
      reduceOther1
      reduceOther2
      reduceOther3
      reduceOther4
      reduceOther5
      reduceDomesticTourismTax
      reduceTravelProductsServicesTax
      reduceShopping
      reduceOTOP
      reduceTravelDecember
      HealthInsurance
      childFrom2018
      reducePregnancy
      SecondaryTourist
      donationHospital
      reduceTire
      reduceBook
      totalReduce
      childAllTotal
      childStudyTotal
    }
    fetchEmployeeFamilyChildDraft {
      childFname1
      childLname1
      childBirthDate1
      childReduce1
      childFname2
      childLname2
      childBirthDate2
      childReduce2
      childFname3
      childLname3
      childBirthDate3
      childReduce3
    }
    fetchTaxDraft(month: $month, year: $year) {
      taxDraftId
      childBirthBefore2561
      childBirthAfter2561
      adoptedChild
      isSponserFather
      isFatherHealthInsurance
      isSponserMother
      isMotherHealthInsurance
      isSponserSpouFather
      spouFatherTitle
      spouFatherFname
      spouFatherLname
      spouFatherIdentNo
      spouFatherReduAmnt
      fatherHealthInsurance
      isSpouFatherHealthInsurance
      spouFaHealthInsurance
      isSponserSpouMother
      spouMotherTitle
      spouMotherFname
      spouMotherLname
      spouMotherIdentNo
      spouMotherReduAmnt
      matherHealthInsurance
      isSpouMotherHealthInsurance
      spouMaHealthInsurance
      isSponserDisabled
      isNumberOfDisabled
      employeeName1
      idCardDisabled1
      lessAllowance1
      relation1
      employeeName2
      idCardDisabled2
      lessAllowance2
      relation2
      employeeName3
      idCardDisabled3
      lessAllowance3
      relation3
      employeeName4
      idCardDisabled4
      lessAllowance4
      relation4
      employeeName5
      idCardDisabled5
      lessAllowance5
      relation5
      employeeName6
      idCardDisabled6
      lessAllowance6
      relation6
      employeeName7
      idCardDisabled7
      lessAllowance7
      relation7
      employeeName8
      idCardDisabled8
      lessAllowance8
      relation8
      employeeName9
      idCardDisabled9
      lessAllowance9
      relation9
      employeeName10
      idCardDisabled10
      lessAllowance10
      relation10
      HealthInsurance
      healthInsurance
      insuraAmount
      rmfDeposit
      ssfDeposit
      interestLoan
      accumulateSocial
      donationEducate
      donationCharity
      month
      year
      updatedAt
      sendDate
      isDelete
    }
    fetchEmployeeSocialSecurity {
      accumulateSocial
      providentFundTax
    }

    fetchEmployeeTaxDisabilityDraft {
      employeename
      idCardDisabled
      lessAllowance
    }

    detailTax {
      taxDraftId
      childBirthBefore2561
      childBirthAfter2561
      adoptedChild
      isSponserFather
      isFatherHealthInsurance
      isSponserMother
      isMotherHealthInsurance
      isSponserSpouFather
      spouFatherFname
      spouFatherLname
      spouFatherIdentNo
      spouFatherReduAmnt
      fatherHealthInsurance
      isSpouFatherHealthInsurance
      spouFaHealthInsurance
      isSponserSpouMother
      spouMotherFname
      spouMotherLname
      spouMotherIdentNo
      spouMotherReduAmnt
      matherHealthInsurance
      isSpouMotherHealthInsurance
      spouMaHealthInsurance
      isSponserDisabled
      isNumberOfDisabled
      employeeName1
      idCardDisabled1
      lessAllowance1
      relation1
      employeeName2
      idCardDisabled2
      lessAllowance2
      relation2
      employeeName3
      idCardDisabled3
      lessAllowance3
      relation3
      employeeName4
      idCardDisabled4
      lessAllowance4
      relation4
      employeeName5
      idCardDisabled5
      lessAllowance5
      relation5
      employeeName6
      idCardDisabled6
      lessAllowance6
      relation6
      employeeName7
      idCardDisabled7
      lessAllowance7
      relation7
      employeeName8
      idCardDisabled8
      lessAllowance8
      relation8
      employeeName9
      idCardDisabled9
      lessAllowance9
      relation9
      employeeName10
      idCardDisabled10
      lessAllowance10
      relation10
      HealthInsurance
      healthInsurance
      insuraAmount
      rmfDeposit
      ssfDeposit
      interestLoan
      accumulateSocial
      donationEducate
      donationCharity
      month
      year
      updatedAt
      sendDate
      isDelete
    }

    fetchEmployeeFamilyTax {
      fatherTitle
      fatherFname
      fatherLname
      fatherIdentNo
      fatherReduAmnt
      motherTitle
      motherFname
      motherLname
      motherIdentNo
      motherReduAmnt
    }

    fetchEmployeeFamilyObj {
      fatherIdentNo
      fatherTitle
      fatherFname
      fatherLname
      motherIdentNo
      motherTitle
      motherFname
      motherLname
    }
  }
`;

const guideLineTax = gql`
  query {
    guideLineTax {
      title
      description
    }
  }
`;

const confirmTextTaxDraft = gql`
  query {
    confirmTextTaxDraft {
      description
    }
  }
`;

const fetchListDropDownMasterData = gql`
  query ($typeMasterData: TypeMasterData) {
    fetchListDropDownMasterData(typeMasterData: $typeMasterData) {
      id
      label
      children {
        id
        label
      }
    }
  }
`;

const fetchListDocumentCategoryMasterData = gql`
  query ($mainSystemId: ID!, $subSystemId: ID!) {
    fetchListDocumentCategoryMasterData(
      mainSystemId: $mainSystemId
      subSystemId: $subSystemId
    ) {
      docCategoryId
      docCategoryName
    }
  }
`;

const fetchListKCMHDocument = gql`
  query (
    $docId: ID
    $mainSystemId: ID
    $subSystemId: ID
    $docCategoryId: ID
    $search: String
    $offset: Int
    $limit: Int
  ) {
    fetchListKCMHDocument(
      docId: $docId
      mainSystemId: $mainSystemId
      subSystemId: $subSystemId
      docCategoryId: $docCategoryId
      search: $search
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        docId
        fileId
        linkFile
        docTitle
        docDescription
        docIcon
        docGroupId
        systemName
        orderNo
        status
        systemId
        activeDate
        createdAt
        updatedAt
        fileData {
          fileId
          fileMimeType
        }
      }
    }
  }
`;

const fetchListKCMHDocumentList = gql`
  query (
    $docId: ID
    $mainSystemId: ID
    $subSystemId: ID
    $docCategoryId: ID
    $search: String
    $offset: Int
    $limit: Int
  ) {
    fetchListKCMHDocument(
      docId: $docId
      mainSystemId: $mainSystemId
      subSystemId: $subSystemId
      docCategoryId: $docCategoryId
      search: $search
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        docId
        fileId
        linkFile
        docTitle
        docDescription
        docIcon
        docGroupId
        systemName
        orderNo
        status
        systemId
        activeDate
        createdAt
        updatedAt
      }
    }
  }
`;

const fetchListDropDownDivisionCDMasterData = gql`
  query {
    fetchListDropDownDivisionCDMasterData {
      id
      name
      nameEn
      parentId
      children {
        id
        name
        nameEn
        parentId
      }
    }
  }
`;

const fetchListKCMHQualityDocument = gql`
  query (
    $docId: ID
    $divisionId: ID
    $docTypeId: ID
    $search: String
    $offset: Int
    $limit: Int
  ) {
    fetchListKCMHQualityDocument(
      docId: $docId
      divisionId: $divisionId
      docTypeId: $docTypeId
      search: $search
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        docId
        fileId
        linkFile
        docTitle
        docDescription
        docIcon
        docGroupId
        systemName
        orderNo
        status
        systemId
        activeDate
        createdAt
        updatedAt
        fileData {
          fileId
          fileMimeType
        }
      }
    }
  }
`;

const fetchListKCMHQualityDocumentList = gql`
  query (
    $docId: ID
    $divisionId: ID
    $docTypeId: ID
    $search: String
    $offset: Int
    $limit: Int
  ) {
    fetchListKCMHQualityDocument(
      docId: $docId
      divisionId: $divisionId
      docTypeId: $docTypeId
      search: $search
      offset: $offset
      limit: $limit
    ) {
      total
      totalPage
      data {
        docId
        fileId
        linkFile
        docTitle
        docDescription
        docIcon
        docGroupId
        systemName
        orderNo
        status
        systemId
        activeDate
        createdAt
        updatedAt
      }
    }
  }
`;

const fetchListDocumentTypeMasterData = gql`
  query ($divisionId: ID) {
    fetchListDocumentTypeMasterData(divisionId: $divisionId) {
      docTypeId
      docTypeName
    }
  }
`;

const dropdownListRelation = gql`
  query {
    dropdownListRelation {
      label
      id
    }
  }
`;

const dropdownListTitleMale = gql`
  query {
    dropdownListTitleMale {
      label
      id
    }
  }
`;

const dropdownListTitleFemale = gql`
  query {
    dropdownListTitleFemale {
      label
      id
    }
  }
`;

const detchProfileListDetail = gql`
  query {
    fetchProfile {
      name
      nameEng
      personId
      title
      firstName
      lastName
      middleName
      titleEng
      firstNameEng
      lastNameEng
      middleNameEng
      militaryStatus
      gender
      birthDate
      identityCard
      identityCardIssueAt
      identityCardDate
      bloodGroups
      nationality
      race
      religion
      passportNo
      maritalStatus
      marryDate
      employeeCodes
      consent
      currentProfile
      divisionName
      isHr
      organizationName
      divisionName
      agencyName
      affAgencyName
    }
    fetchEmployeeProfile {
      empCode
      hnNo
      licenseNo
      agency
      remark
      carpark
      carparkRemark
      hnNo_somdej
      refCarpark {
        id
        textTh
        textEn
        isDefault
      }
      refCode
      payWagesType
      benefits
      workingProfile {
        startDate
        endDate
        orgPosition {
          orgUnitId
          positionId
          positionCode
          positionName
          positionNameEng
        }
        orgUnit {
          orgId
          orgUnitTypeId
          orgUnitId
          orgUnitCode
          orgUnitName
          orgUnitNameEng
          parentOrgUnit
        }
        positionManage {
          posManageName
        }
        positionTechnical {
          posTechnicalName
        }
        empLevel {
          emplLevelCode
          empLevelName
          emplLevelName
        }
      }
      address {
        addressId
        addressNo
        addressName
        groupNo
        building
        roomNo
        floorNo
        vilage
        lane
        street
        district
        amphur
        province
        postalCode
        country
        contactName
        mobilePhone
        phone1
        phone2
        phone3
        fax
        email1
        email2
        email3
      }
      workingStatus
      employDate
      licenseExpirationDate
    }
    fetchEmployeeEmplGroup {
      emplGrupId
      emplGrupCode
      emplGrupName
      emplGrupNameEng
      remark
    }
    fetchAddress {
      addressId
      addressName
      addressNo
      groupNo
      building
      roomNo
      floorNo
      vilage
      lane
      street
      district
      amphur
      province
      postalCode
      country
      email1
      phone1
      updatedAt
      sendDate
      isDelete
    }
  }
`;

const fetchUrlConicleMyPolicy = gql`
  query {
    fetchUrlConicleMyPolicy {
      url
    }
  }
`;

const fetchUrlConicleRequestPolicy = gql`
  query {
    fetchUrlConicleRequestPolicy {
      url
    }
  }
`;

const fetchUrlConicleAllPolicy = gql`
  query {
    fetchUrlConicleAllPolicy {
      url
    }
  }
`;

const fetchApplicationSetting = gql`
  query {
    fetchApplicationSetting {
      linkFund
    }
  }
`;

const fetchCountAllNotification = gql`
  query {
    fetchCountAllNotification
  }
`;

const fetchUrlTax6Month = gql`
  query (
    $month: String!
    $year: String!
    $identityCard: String!
    $profileKey: String!
  ) {
    fetchUrlTax6Month(
      month: $month
      year: $year
      identityCard: $identityCard
      profileKey: $profileKey
    ) {
      linkPDF
    }
  }
`;

const dropdownListProvince = gql`
  query {
    dropdownListProvince {
      id
      parentId
      name
      nameEn
      postCode
      type
    }
  }
`;

const dropdownListAmphur = gql`
  query ($id: String!) {
    dropdownListAmphur(id: $id) {
      id
      parentId
      name
      nameEn
      postCode
      type
    }
  }
`;

const dropdownListDistrict = gql`
  query ($id: String!) {
    dropdownListDistrict(id: $id) {
      id
      parentId
      name
      nameEn
      postCode
      type
    }
  }
`;

const fetchUrlTaxYears = gql`
  query (
    $month: String!
    $year: String!
    $identityCard: String!
    $profileKey: String!
  ) {
    fetchUrlTaxYears(
      month: $month
      year: $year
      identityCard: $identityCard
      profileKey: $profileKey
    ) {
      linkPDF
    }
  }
`;

const dropDownSlipPayment = gql`
  query ($month: String!, $year: String!, $profileKey: String!) {
    dropDownSlipPayment(month: $month, year: $year, profileKey: $profileKey) {
      id
      label
    }
  }
`;

const fetchNotification = gql`
  query ($notificationId: ID!) {
    fetchNotification(notificationId: $notificationId) {
      notificationId
      title
      body
      postId
      docId
      courseId
      redirectPath
      createdAt
      read
      isConfirm
      confirm
      dateConfirm
      division
      notiFrom
    }
  }
`;

const redirectWDHospitalPath = gql`
  query ($wdHospitalId: String!, $type: RedirectWDHospitalType!) {
    redirectWDHospitalPath(wdHospitalId: $wdHospitalId, type: $type) {
      wdHospitalId
      type
      status
    }
  }
`;

const fetchUrlConicleRedirectPath = gql`
  query ($redirectPath: String) {
    fetchUrlConicleRedirectPath(redirectPath: $redirectPath) {
      url
    }
  }
`;

const fetchListSearchWDHospital = gql`
  query (
    $wdHospitalId: ID
    $empFirstName: String
    $empLastName: String
    $withdrawFirstName: String
    $withdrawLastName: String
    $department: String
    $division: String
    $startDate: Date
    $endDate: Date
    $status: String
    $searchKeyword: String
    $searchType: SearchDetailType!
  ) {
    fetchListWDHospital(
      wdHospitalId: $wdHospitalId
      empFirstName: $empFirstName
      empLastName: $empLastName
      withdrawFirstName: $withdrawFirstName
      withdrawLastName: $withdrawLastName
      department: $department
      division: $division
      startDate: $startDate
      endDate: $endDate
      status: $status
      searchKeyword: $searchKeyword
      searchType: $searchType
    ) {
      withdrawNo
      wdHospitalId
      empFirstName
      empLastName
      withdrawFirstName
      withdrawLastName
      relation
      age
      department
      division
      totalWithdraw
      date
      status
      hospitalName
      hospitalType
      sicknessName
      sicknessId
      patientType
      privateCase
      payDate
      note
      noteApprove
      totalCurrentWithdraw
      hospitalDetail
      createdAt
      refDocument
      cashFlg
      resignationDate
      workingStatus
      coaCodeName
      slip {
        totalSlipWithdraw
        slipNo
        numberSlip
        date
        totalPrice
      }
      approver {
        level
        role
        empCode
        canEdit
      }
      documentMultiFile {
        wdHospitalDocumentId
        documentType
        description
        fileData {
          fileId
          fileMimeType
        }
        fileLink
      }
      exportPayDate
    }
  }
`;

const fetchListWDHospital = gql`
  query (
    $wdHospitalId: ID
    $empFirstName: String
    $empLastName: String
    $withdrawFirstName: String
    $withdrawLastName: String
    $department: String
    $division: String
    $startDate: Date
    $endDate: Date
    $status: String
    $searchType: SearchDetailType!
  ) {
    fetchListWDHospital(
      wdHospitalId: $wdHospitalId
      empFirstName: $empFirstName
      empLastName: $empLastName
      withdrawFirstName: $withdrawFirstName
      withdrawLastName: $withdrawLastName
      department: $department
      division: $division
      startDate: $startDate
      endDate: $endDate
      status: $status
      searchType: $searchType
    ) {
      empCode
      withdrawNo
      wdHospitalId
      empFirstName
      empLastName
      withdrawFirstName
      withdrawLastName
      relation
      age
      department
      division
      totalWithdraw
      date
      status
      hospitalName
      hospitalType
      sicknessName
      patientType
      privateCase
      note
      noteApprove
      totalCurrentWithdraw
      sicknessId
      isJuristic
      hospitalBankDetail
      hospitalBankAccountId
      hospitalDetail
      withdrawIdCard
      treatmentStartDate
      treatmentEndDate
      refDocument
      cashFlg
      resignationDate
      workingStatus
      coaCodeName
      empAffiliationOrgCode
      isPension
      medCert {
        wdHospitalDocumentId
        documentType
        description
        fileData {
          idFile
          fileId
          fileMimeType
        }
        fileLink
      }
      slip {
        totalSlipWithdraw
        wdSlipId
        slipNo
        numberSlip
        date
        totalPrice
        fileData {
          idFile
          fileId
          fileMimeType
        }
      }
      approver {
        level
        role
        empCode
        canEdit
      }
      document {
        wdHospitalDocumentId
        documentType
        description
        fileData {
          fileId
          fileMimeType
        }
        fileLink
      }
      documentMultiFile {
        wdHospitalDocumentId
        documentType
        description
        fileData {
          idFile
          fileId
          fileMimeType
        }
        fileLink
      }
      payDate
      exportPayDate
      createdAt
      createdBy
      empTypeLabel
    }
  }
`;

const fetchMedicalExpensesLicensee = gql`
  query ($empCode: String) {
    fetchMedicalExpensesLicensee(empCode: $empCode) {
      fullName
      identitycard
      relationship
      relationShipLabel
      title
      firstName
      lastName
      birthDate
      age
    }
  }
`;

const dropdownListHospitalBankAccount = gql`
  query ($hospitalId: ID!) {
    dropdownListHospitalBankAccount(hospitalId: $hospitalId) {
      label
      id
    }
  }
`;

const dropdownMedicalExpensesLicensee = gql`
  query ($empCode: String) {
    dropdownMedicalExpensesLicensee(empCode: $empCode) {
      label
      value
    }
  }
`;

const fetchApproverMedical = gql`
  query {
    fetchApproverMedical {
      users {
        label
        value
      }
      level
      approveType
      approveLabel
      canEdit
    }
  }
`;

const dropdownListHospital = gql`
  query {
    dropdownListHospital {
      label
      id
    }
  }
`;

const dropdownListSickness = gql`
  query {
    dropdownListSickness {
      label
      id
    }
  }
`;

const fetchHospital = gql`
  query ($hospitalId: ID!) {
    fetchHospital(hospitalId: $hospitalId) {
      hospitalId
      hospitalCode
      hospitalName
      hospitalShortName
      affiliation
      province
      address
      phoneNumber
      affiliationNew
      hospitalBankAccounts {
        hospitalBankAccountId
        bankName
        bankId
        bookBankAccount
        bookBankName
        bankBranchCode
        updatedBy
        updatedAt
        isActive
        isDisableToggle
        isDefault
        file {
          fileData {
            fileId
            fileMimeType
          }
          fileLink
        }
      }
      updatedBy
      updatedAt
      bankCode
      bookBankAccount
      bookBankName
    }
  }
`;

const fetchOptionApprover = gql`
  query ($wdHospitalId: ID!) {
    fetchOptionApprover(wdHospitalId: $wdHospitalId) {
      level
      role
      empCode
      canEdit
    }
  }
`;

const fetchListWDHospitalApprover = gql`
  query ($startDate: Date, $endDate: Date, $status: String) {
    fetchListWDHospitalApprover(
      startDate: $startDate
      endDate: $endDate
      status: $status
    ) {
      sicknessName
      sicknessId
      withdrawNo
      wdHospitalId
      empFirstName
      empLastName
      withdrawFirstName
      withdrawLastName
      relation
      age
      department
      division
      totalWithdraw
      totalCurrentWithdraw
      orgName
      orgCode
      date
      status
      hospitalName
      hospitalType
      patientType
      privateCase
      note
      noteApprove
      refDocument
      cashFlg
      resignationDate
      workingStatus
      isPension
      empAffiliationOrgCode
      slip {
        totalSlipWithdraw
        wdSlipId
        slipNo
        numberSlip
        date
        totalPrice
        fileData {
          fileId
          fileMimeType
        }
      }
      approver {
        level
        role
        empCode
        canEdit
      }
      createdAt
    }
  }
`;

const fetchListSearchWDHospitalApprover = gql`
  query (
    $startDate: Date
    $endDate: Date
    $status: String
    $searchKeyword: String
  ) {
    fetchListWDHospitalApprover(
      startDate: $startDate
      endDate: $endDate
      status: $status
      searchKeyword: $searchKeyword
    ) {
      sicknessName
      wdHospitalId
      withdrawNo
      empFirstName
      empLastName
      withdrawFirstName
      withdrawLastName
      relation
      age
      department
      division
      totalWithdraw
      totalCurrentWithdraw
      date
      status
      hospitalName
      hospitalType
      sicknessName
      patientType
      privateCase
      note
      noteApprove
      orgName
      orgCode
      refDocument
      cashFlg
      resignationDate
      workingStatus
      isPension
      empAffiliationOrgCode
      isJuristic
      slip {
        totalSlipWithdraw
        slipNo
        numberSlip
        date
        totalPrice
      }
      approver {
        level
        role
        empCode
        canEdit
      }
      createdAt
    }
  }
`;

const fetchWDHospitalHistory = gql`
  query ($wdHospitalId: ID!) {
    fetchWDHospitalHistory(wdHospitalId: $wdHospitalId) {
      sicknessName
      sicknessId
      withdrawNo
      wdHospitalId
      empFirstName
      empLastName
      withdrawFirstName
      withdrawLastName
      relation
      relationShipLabel
      age
      department
      division
      totalWithdraw
      date
      status
      hospitalName
      hospitalType
      patientType
      privateCase
      note
      noteApprove
      orderNo
      createdAt
      userAction
      action
    }
  }
`;

const fetchLeaveDocumentList = gql`
  query (
    $empCode: String
    $leaveStartDate: Date
    $leaveEndDate: Date
    $leaveTypeId: ID
    $approveStatus: String!
    $searchKeyword: String
  ) {
    fetchLeaveDocumentList(
      empCode: $empCode
      leaveStartDate: $leaveStartDate
      leaveEndDate: $leaveEndDate
      leaveTypeId: $leaveTypeId
      approveStatus: $approveStatus
      searchKeyword: $searchKeyword
    ) {
      docId
      documentDate
      employeeName
      identitycard
      leaveTypeCode
      leaveTypeName
      leaveStartDate
      leaveEndDate
      leaveDay
      approveStatus
      isCancelByReq
      department
      division
      shiftId
      leaveStartTime
      leaveEndTime
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      leaveHour {
        label
        value
      }
      createdAt
      orgCode
      orgName
      docNo
      wdLeaveId
    }
  }
`;

const dropdownLeaveType = gql`
  query ($empCode: String, $isReqByEmp: Boolean) {
    dropdownLeaveType(empCode: $empCode, isReqByEmp: $isReqByEmp) {
      leaveTypeId
      leaveTypeCode
      leaveTypeName
      isFullDayLeave
      isCanLeaveOver
      maxLeaveDay
      minLeaveDay
      earlyLeaveDay
      backLeaveDay
      reqAttachDay
      isAutoApprove
      isCancelByReq
      dropdownDurationType {
        label
        value
      }
      label
      value
    }
  }
`;

const fetchLeaveDay = gql`
  query ($empCode: String, $reqLeaveDate: Date!, $leaveTypeId: ID!) {
    fetchLeaveDay(
      empCode: $empCode
      reqLeaveDate: $reqLeaveDate
      leaveTypeId: $leaveTypeId
    ) {
      leaveDay
      currentLeaveDay
      remainLeaveDay
    }
  }
`;

const fetchWorkingDay = gql`
  query ($leaveTypeId: ID!, $leaveStartDate: Date!, $leaveEndDate: Date!) {
    fetchWorkingDay(
      leaveTypeId: $leaveTypeId
      leaveStartDate: $leaveStartDate
      leaveEndDate: $leaveEndDate
    ) {
      day
    }
  }
`;

const fetchLeaveDocumentDetail = gql`
  query ($docId: ID) {
    fetchLeaveDocumentDetail(docId: $docId) {
      wdLeaveId
      docId
      documentDate
      identitycard
      leaveTypeId
      leaveTypeCode
      leaveTypeName
      leaveStartDate
      leaveEndDate
      durationType
      durationLabel
      leaveDay
      approveStatus
      description
      docNo
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      isShowApproveButton
      attachFiles {
        fileId
        description
        documentType
        fileType
        attachFile
      }
      orgCode
      empCode
      isCancelByReq
      shiftId
      leaveStartTime
      leaveEndTime
      shiftCode
      shiftTime
      leaveHour {
        label
        value
      }
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
    }
  }
`;

const fetchLeaveDocumentDetailStatus = gql`
  query ($docId: ID) {
    fetchLeaveDocumentDetailStatus(docId: $docId) {
      docId
      status
    }
  }
`;

const fetchLeaveDocumentDetailDraf = gql`
  query ($wdLeaveId: String!) {
    fetchLeaveDocumentDetailDraf(wdLeaveId: $wdLeaveId) {
      wdLeaveId
      docId
      documentDate
      identitycard
      leaveTypeId
      leaveTypeCode
      leaveTypeName
      leaveStartDate
      leaveEndDate
      durationType
      durationLabel
      leaveDay
      approveStatus
      description
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      attachFiles {
        fileId
        description
        documentType
        fileType
        attachFile
        base64
        fileName
      }
      orgCode
      empCode
      isCancelByReq
      shiftId
      leaveStartTime
      leaveEndTime
      shiftCode
      shiftTime
      leaveHour {
        label
        value
      }
      docNo
      approvers {
        level
        approveType
        empCode
      }
    }
  }
`;

const fetchListLeaveDocumentApprover = gql`
  query (
    $leaveStartDate: Date
    $leaveEndDate: Date
    $leaveType: String
    $approveStatus: String
  ) {
    fetchListLeaveDocumentApprover(
      leaveStartDate: $leaveStartDate
      leaveEndDate: $leaveEndDate
      leaveType: $leaveType
      approveStatus: $approveStatus
    ) {
      wdLeaveId
      employeeName
      department
      division
      durationType
      leaveTypeLabel
      leaveType
      leaveStartDate
      leaveEndDate
      leaveDay
      empCode
      docId
      status
      level
      noteApprove
      createdAt
      division
      department
      orgCode
      orgName
      docNo
      description
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      leaveHour {
        label
        value
      }
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
    }
  }
`;

const fetchLeaveDocumentHistory = gql`
  query ($docId: ID!) {
    fetchLeaveDocumentHistory(docId: $docId) {
      docId
      leaveStartDate
      leaveEndDate
      durationType
      leaveDay
      approveStatus
      noteApprove
      userAction
      createdAt
    }
  }
`;

const fetchApproverLeave = gql`
  query ($empCode: String, $leaveTypeId: ID!, $leaveDay: Float!, $fiscalYear: String) {
    fetchApproverLeave(
      empCode: $empCode
      leaveTypeId: $leaveTypeId
      leaveDay: $leaveDay
      fiscalYear: $fiscalYear
    ) {
      users {
        label
        value
      }
      level
      canEdit
      approveType
      approveLabel
    }
  }
`;

const fetchOptionApproverLeave = gql`
  query ($docId: ID!) {
    fetchOptionApproverLeave(docId: $docId) {
      level
      role
      empCode
      canEdit
    }
  }
`;

const fetchEmployeeDetail = gql`
  query ($empCode: String!) {
    fetchEmployeeDetail(empCode: $empCode) {
      empCode
      identityCard
      title
      firstName
      lastName
      orgCode
      orgName
      orgUnitCode
      orgUnitName
      diviCode
      diviName
      deptCode
      deptName
      resignationDate
      workingStatus
      isPension
      empAffiliationOrgCode
      emplGrupCode
      emplGrupName
      emplLevelCode
      emplLevelName
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      emplGrupCode
      emplGrupName
      emplLevelCode
      emplLevelName
      orgUnitCode
      orgUnitName
      diviCode
      diviName
      deptCode
      displayConfig {
        showLv
        lv1
        lv2
        lv3
        lv4
        lv5
        screenName
      }
    }
  }
`;

const fetchEmployeeProfileHistory = gql`
  query (
    $dataType: DataType
    $startDate: Date
    $endDate: Date
    $search: String
    $documentNo: String
  ) {
    fetchEmployeeProfileHistory(
      dataType: $dataType
      startDate: $startDate
      endDate: $endDate
      search: $search
      documentNo: $documentNo
    ) {
      idCard
      dataDate
      dataType
      dataMessage
      sourceDb
      documentNo
    }
  }
`;

const fetchListChildTuitions = gql`
  query (
    $empCode: String
    $tuitionDTID: String
  ) {
    fetchListChildTuitions(
      empCode: $empCode
      tuitionDTID: $tuitionDTID
    ) {
      empCode
      identifyCard
      tuitionDTID
      documentNo
      documentCreatedDate
      eduStatus
      childNo
      childFullName
      educationLevel
      eduGrade
      eduYear
      semaster
      academyType
      eduPeriod
      payDate
      amount
      sourceDB
      childTuitionHistory {
        tuitionDTID
        transactionDate
        transactionBy
        status
        remark
      }
    }
  }
`;

const fetchListDelegateApprover = gql`
  query ($empCode: String, $isActive: Int, $docType: String) {
    fetchListDelegateApprover(
      empCode: $empCode
      isActive: $isActive
      docType: $docType
    ) {
      delegateId
      docType
      fromEmpCode
      toEmpCode
      isActive
      startDate
      endDate
      note
      createdBy
      revokeBy
      userDelegateName
    }
  }
`;

const fetchListDelegator = gql`
  query ($orgCode: String) {
    fetchListDelegator(orgCode: $orgCode) {
      empCode
      fullName
      orgUnitCode
      orgUnitName
      posManageCode
      posManageName
    }
  }
`;

const fetchCountListAllApproving = gql`
  query {
    fetchCountListAllApproving {
      all
      wdHospitalCount
      leaveCount
    }
  }
`;

const checkIsEmployeeProfileHistoryActive = gql`
  query {
    checkIsEmployeeProfileHistoryActive {
      status
    }
  }
`;

const fetchLeaveDayAll = gql`
  query ($empCode: String, $reqLeaveDate: Date!) {
    fetchLeaveDayAll(empCode: $empCode, reqLeaveDate: $reqLeaveDate) {
      leaveTypeId
      leaveTypeCode
      leaveTypeName
      leaveDay
      currentLeaveDay
      remainLeaveDay
      leaveYearStartDate
      leaveYearEndDate
      isShowRemaVtrc
    }
  }
`;

const fetchSalaryCert = gql`
  query ($identityCard: String!, $profileKey: String) {
    fetchSalaryCert(identityCard: $identityCard, profileKey: $profileKey) {
      dropdownLang {
        id
        label
      }
      isDisable
    }
  }
`;

const fetchUrlSalaryCert = gql`
  query ($documentType: String, $empCode: String, $profileKey: String) {
    fetchUrlSalaryCert(
      documentType: $documentType
      empCode: $empCode
      profileKey: $profileKey
    ) {
      linkPDF
    }
  }
`;

const fetchConditionSalaryCertText = gql`
  query ($profileKey: String) {
    fetchConditionSalaryCertText(profileKey: $profileKey)
  }
`;

const fetchUrlWDHospitalApproverPDFReport = gql`
  query ($empCode: String) {
    fetchUrlWDHospitalApproverPDFReport(empCode: $empCode) {
      linkPDF
    }
  }
`;

const dropDownTypeSalaryCert = gql`
  query ($profileKey: String) {
    dropDownTypeSalaryCert(profileKey: $profileKey) {
      label
      id
    }
  }
`;

const dropDownTypeSalaryCertForBank = gql`
  query ($profileKey: String) {
    dropDownTypeSalaryCertForBank(profileKey: $profileKey) {
      label
      id
    }
  }
`;

const fetchAllProvidentFundDetail = gql`
  query {
    fetchAllProvidentFundDetail {
      employeeFundPolicy {
        provEmployerDeduct
        provEmployeeDeduct
        provStartDate
        provEndDate
        fundPolicyName
        policyFixedRate
        policyMixRate
        policyEquityRate
        memberStatus
        provBeginAmount
        provEndAmount
        providentFundRateId
      }
      providentFundRateHistory {
        provRateHistory {
          provEmployerDeduct
          provEmployeeDeduct
          createdDate
          providentFundName
          modifiedDate
        }
        isBtnActive
      }
      providentFundBenefitsPerson {
        benefitsPerson {
          benefitsName
          listNo
          benefitsIdCard
          benefitsRate
        }
        isBtnActive
        isCanEdit
      }
      fundPolicy {
        fyi
        link
        isBtnActive
      }
      applicationProvidentFund {
        fyi
        link
        isBtnActive
        fileData {
          fileId
          fileMimeType
          idFile
        }
      }
      empFundStatusType
    }
  }
`;

const fetchConfigChangeProvPercentage = gql`
  query {
    fetchConfigChangeProvPercentage {
      providentFundEffectiveDate
      provChangeDateTo
      provChangeDateFrom
      salary
      changeMin
      changeMax
      fundPolicyId
      provEmployeeDeduct
      isCanEdit
    }
  }
`;

const fetchFundChangeHistory = gql`
  query {
    fetchFundChangeHistory {
      fundRequestId
      requestType
      syncDate
      status
      updatedBy
      updatedAt
      fundChangeDetail {
        salary
        provEmployeeDeduct
      }
    }
  }
`;
const fetchFundChangeBenefitPersonDetail = gql`
  query ($fundRequestId: ID!) {
    fetchFundChangeBenefitPersonDetail(fundRequestId: $fundRequestId) {
      fundRequestNo
      remark
      benefitPersons {
        fundBenefitPersonId
        providentFundRateId
        benefitsName
        listNo
        benefitsIdCard
        benefitsRate
        address
        relationShip
      }
      fundDocument {
        fundDocumentId
        documentType
        description
        fileData {
          fileId
          fileMimeType
          idFile
        }
        fileLink
      }
      status
    }
  }
`;

const dropdownRelationShipLabel = gql`
  query {
    dropdownRelationShipLabel
  }
`;

const fetchListChildDetailInTuition = gql`
  query {
    fetchListChildDetailInTuition {
      childNo
      childFullName
      educationLevel
      eduGrade
      eduYear
      totalAmount
      remainingTuition
      listNo
    }
  }
`;

const fetchEachChildTuitionDetail = gql`
  query ($eduYear: String, $eduStatus: String, $childNo: Int!) {
    fetchEachChildTuitionDetail(
      eduYear: $eduYear
      eduStatus: $eduStatus
      childNo: $childNo
    ) {
      empCode
      identifyCard
      tuitionDTID
      documentNo
      documentCreatedDate
      eduStatus
      childNo
      childFullName
      educationLevel
      eduGrade
      eduYear
      semaster
      academyType
      eduPeriod
      payDate
      amount
      sourceDB
      childTuitionHistory {
        tuitionDTID
        transactionDate
        transactionBy
        status
        remark
      }
    }
  }
`;

const fetchEmpwithCoA = gql`
  query (
    $empCode: String!
    $affiliation: String!
    $patientType: String!
    $relation: String!
    $isPension: Boolean!
  ) {
    fetchEmpwithCoA(
      empCode: $empCode
      affiliation: $affiliation
      patientType: $patientType
      relation: $relation
      isPension: $isPension
    )
  }
`;

const fetchLeaveShiftTime = gql`
  query ($empCode: String!, $workDate: Date!) {
    fetchLeaveShiftTime(empCode: $empCode, workDate: $workDate) {
      shiftId
      shiftCode
      shiftName
      shiftTime
      timeIn
      timeOut
      startBreakTime
      endBreakTime
    }
  }
`;

const fetchLeaveHour = gql`
  query ($shiftId: String!, $leaveStartTime: String!, $leaveEndTime: String!) {
    fetchLeaveHour(
      shiftId: $shiftId
      leaveStartTime: $leaveStartTime
      leaveEndTime: $leaveEndTime
    ) {
      label
      value
    }
  }
`;

const fetchTotalDayOff = gql`
  query (
    $empCode: String
    $leaveType: String
    $searchKeyword: String
    $isOptional: Boolean
  ) {
    fetchTotalDayOff(
      empCode: $empCode
      leaveType: $leaveType
      searchKeyword: $searchKeyword
      isOptional: $isOptional
    ) {
      empCode
      employeeName
      department
      division
      leaveType
      totalDayOff
    }
  }
`;

const fetchListStudyLeaveRequest = gql`
  query (
    $offset: Int
    $limit: Int
    $orgCode: String
    $empCode: String
    $searchKeyword: SearchObject
    $studyLeaveStatus: String
    $viewMode: Boolean!
  ) {
    fetchListStudyLeaveRequest(
      offset: $offset
      limit: $limit
      orgCode: $orgCode
      empCode: $empCode
      searchKeyword: $searchKeyword
      studyLeaveStatus: $studyLeaveStatus
      viewMode: $viewMode
    ) {
      total
      totalPage
      data {
        studyLeaveRequestId
        empCode
        empName
        position
        empSalary
        empGroup
        departmentName
        organizationCode
        organizationName
        empLevel
        divisionName
        studyLeaveNo
        leaveResultName
        studyLeaveDocumentNo
        studyLeaveDocumentDate
        studyLeaveResult
        currentRevision
        studyLeaveStatus
        studyLeaveRemark
        userId
        createdAt
        createdBy
        updatedAt
        updatedBy
        requestAt
        requestBy
        studyLeaveDetail {
          createdAt
          updatedAt
          studyLeaveDetailId
          studyLeaveRequestId
          studyLeaveRevision
          studyLeaveDegree
          studyLeaveCourse
          studyLeaveEducational
          studyLeaveMajor
          studyLeaveAcademy
          studyLeaveCountry
          isForeign
          studyLeaveDuration
          studyLeaveStartDate
          studyLeaveEndDate
          studyLeaveType
          studyLeavePayType
          studyLeaveRemark
          studyLeaveStrategyYear
          studyLeaveReturnDate
          createdBy
          updatedBy
        }
        studyStrategy {
          createdAt
          updatedAt
          studyStrategyId
          studyLeaveRequestId
          studyStrategySort
          studyStrategyName
          studyStrategyGoals
          studyStrategyOutput
          createdBy
          updatedBy
        }
        studyLearnRecord {
          createdAt
          updatedAt
          studyLearnRecordId
          studyLeaveRequestId
          studyLearnTerm
          studyLearnYear
          studyLearnGrade
          studyLearnRemark
          createdBy
          updatedBy
        }
        studyExtend {
          createdAt
          updatedAt
          studyExtendId
          studyLeaveRequestId
          studyExtendSort
          studyExtendDocumentNo
          studyExtendRound
          studyExtendDocumentDate
          studyExtendDateFrom
          studyExtendDateTo
          studyEducational
          studyExtendType
          studyExtendRemark
          studyExtendRevision
          studyExtendPaidType
          createdBy
          updatedBy
        }
        studyEducationFee {
          createdAt
          updatedAt
          studyEducationFeeId
          studyLeaveRequestId
          studyEducationFeeTerm
          studyEducationFeeYear
          studyEducationPrice
          studyEducationStatus
          studyEducationPaidDate
          studyEducationActualPrice
          studyEducationRemark
          studyEducationFeeStatusName
          createdBy
          updatedBy
        }
        studyScholarship {
          createdAt
          updatedAt
          studyScholarshipId
          studyLeaveRequestId
          studyScholarRevision
          studyScholarContractNo
          studyScholarContractDate
          studyScholarContractType
          studyScholarContractSignDate
          studyScholarBenefit
          studyScholarGuarantorName_1
          studyScholarGuarantorIdCard_1
          studyScholarGuarantorRelationShip_1
          studyScholarGuarantorJob_1
          studyScholarGuarantorPosition_1
          studyScholarGuarantorSalaryPerMonth_1
          studyScholarGuarantorSalaryPerYear_1
          studyScholarGuarantorMaritalStatus_1
          studyScholarGuarantorAddress_1
          studyScholarGuarantorName_2
          studyScholarGuarantorIdCard_2
          studyScholarGuarantorRelationShip_2
          studyScholarGuarantorJob_2
          studyScholarGuarantorPosition_2
          studyScholarGuarantorSalaryPerMonth_2
          studyScholarGuarantorSalaryPerYear_2
          studyScholarGuarantorMaritalStatus_2
          studyScholarGuarantorAddress_2
          createdBy
          studyScholarshipDetail {
            createdAt
            updatedAt
            studyScholarshipDetailId
            studyScholarshipId
            studyScholarshipDetailSort
            studyScholarshipDetailName
            studyScholarshipDetailSource
            studyScholarshipDetailBenefit
            createdBy
            updatedBy
          }
        }
        studyHistory {
          createdAt
          updatedAt
          studyHistoryId
          studyLeaveRequestId
          studyHistoryAction
          studyHistoryActionBy
          studyHistoryActionDatetime
          studyHistoryStatus
          studyHistoryRemark
          createdBy
          updatedBy
        }
        studyAttachment {
          createdAt
          updatedAt
          studyAttachmentRefId
          studyFileName
          studyFileType
          studyFilePath
          fileData {
            fileId
            fileMimeType
            idFile
          }
          studyAttachmentId
          studyLeaveRequestId
          studyAttachmentSort
          studyAttachmentType
          studyAttachmentDetail
          studyAttachmentRemark
          createdBy
          updatedBy
        }
        subDeptCode
        subDeptName
        childSubDeptCode
        childSubDeptName
      }
    }
  }
`;

const fetchMasterConfigTypeLeave = gql`
  query {
    fetchMasterConfigTypeLeave {
      configId
      configGroup
      configType
      typeValue
      configValue1
      configValue2
      isActive
      updatedBy
      updatedAt
    }
  }
`;

const fetchStudyLeaveRequestById = gql`
  query ($studyLeaveRequestId: ID!) {
    fetchStudyLeaveRequestById(studyLeaveRequestId: $studyLeaveRequestId) {
      userId
      empCode
      empName
      position
      empSalary
      empGroup
      empLevel
      divisionName
      organizationCode
      organizationName
      departmentName
      studyLeaveNo
      studyLeaveDocumentNo
      studyLeaveDocumentDate
      studyLeaveResult
      currentRevision
      studyLeaveStatus
      studyLeaveRemark
      leaveResultName
      requestName
      createdAt
      createdBy
      updatedBy
      studyLeaveType
      studyLeaveTypeName
      studyLeaveDocumentApprove
      posManageName
      posTechnicalName
      studyLeaveDetail {
        studyLeaveDetailId
        studyLeaveRequestId
        studyLeaveRevision
        studyLeaveDegree
        studyLeaveCourse
        studyLeaveEducational
        studyLeaveMajor
        studyLeaveAcademy
        studyLeaveCountry
        isForeign
        studyLeaveDuration
        studyLeaveReturnDate
        studyLeaveReturnDocument
        studyLeaveReturnDocumentDate
        studyLeaveStartDate
        studyLeaveEndDate
        studyLeaveType
        studyLeavePayType
        studyLeaveRemark
        studyLeaveStrategyYear
        createdBy
        updatedBy
        createdAt
        updatedAt
        isPublishJournal
      }
      studyLearnRecord {
        studyLearnRecordId
        studyLeaveRequestId
        studyLearnTerm
        studyLearnYear
        studyLearnGrade
        studyLearnGPAX
        studyLearnRecordRefId
        studyFileName
        studyFileType
        studyFilePath
        studyLearnRemark
        studyLearnReviewName
        studyLearnReview
        studyLearnReviewBy
        studyLearnReviewAt
        studyLearnReviewRemark
        createdBy
        updatedBy
        createdAt
        updatedAt
      }
      studyExtend {
        studyExtendId
        studyLeaveRequestId
        studyExtendSort
        studyExtendDocumentNo
        studyExtendRound
        studyExtendDocumentDate
        studyExtendTypeName
        studyExtendDateFrom
        studyExtendDateTo
        studyEducational
        studyExtendType
        studyExtendPaidType
        studyExtendRemark
        studyExtendRevision
        createdBy
        updatedBy
        studyExtendDetail
      }
      studyEducationFee {
        studyEducationFeeId
        studyLeaveRequestId
        studyEducationFeeTerm
        studyEducationFeeYear
        studyEducationPrice
        studyEducationActualPrice
        studyEducationStatus
        studyEducationPaidDate
        studyEducationRemark
        studyEducationFeeStatusName
        createdBy
        updatedBy
        createdAt
        updatedAt
      }
      studyAttachment {
        studyAttachmentId
        studyAttachmentSort
        studyAttachmentType
        studyAttachmentRefId
        studyFileName
        studyFileType
        studyFilePath
        studyAttachmentDetail
        createdBy
        updatedBy
        createdAt
        updatedAt
        studyAttachmentTypeName
      }
      studyScholarship {
        createdAt
        updatedAt
        studyScholarshipDetail {
          createdAt
          updatedAt
          studyScholarshipDetailId
          studyScholarshipId
          studyScholarshipDetailSort
          studyScholarshipDetailName
          studyScholarshipDetailSource
          studyScholarshipDetailBenefit
          createdBy
          updatedBy
        }
        studyScholarshipId
        studyLeaveRequestId
        studyScholarRevision
        studyScholarContractNo
        studyScholarContractDate
        studyScholarContractType
        studyScholarContractSignDate
        studyScholarBenefit
        studyScholarGuarantorName_1
        studyScholarGuarantorIdCard_1
        studyScholarGuarantorRelationShip_1
        studyScholarGuarantorJob_1
        studyScholarGuarantorPosition_1
        studyScholarGuarantorSalaryPerMonth_1
        studyScholarGuarantorSalaryPerYear_1
        studyScholarGuarantorMaritalStatus_1
        studyScholarGuarantorAddress_1
        studyScholarGuarantorName_2
        studyScholarGuarantorIdCard_2
        studyScholarGuarantorRelationShip_2
        studyScholarGuarantorJob_2
        studyScholarGuarantorPosition_2
        studyScholarGuarantorSalaryPerMonth_2
        studyScholarGuarantorSalaryPerYear_2
        studyScholarGuarantorMaritalStatus_2
        studyScholarGuarantorAddress_2
      }
      studyStrategy {
        studyStrategyId
        studyLeaveRequestId
        studyStrategySort
        studyStrategyName
        studyStrategyGoals
        studyStrategyOutput
        createdBy
        updatedBy
      }
      studyHistory {
        createdAt
        updatedAt
        studyHistoryId
        studyLeaveRequestId
        studyHistoryAction
        studyHistoryActionBy
        studyHistoryActionDatetime
        studyHistoryStatus
        studyHistoryRemark
        createdBy
        updatedBy
      }
      studyReturnDetail {
        createdAt
        updatedAt
        studyReturnDetailId
        studyLeaveRequestId
        studyReturnRound
        studyReturnDate
        studyReturnDocument
        studyReturnDocumentDate
        createdBy
        updatedBy
      }
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName
      studyLeaveHrDate
      graduationDate
    }
  }
`;

const dropDownstudyLeaveYear = gql`
  query ($studyLeaveRequestId: String!) {
    dropDownstudyLeaveYear(studyLeaveRequestId: $studyLeaveRequestId) {
      label
      value
    }
  }
`;

const fetchDetailProfileListCC = gql`
  query ($search: String, $orgCode: String, $page: Int, $pageSize: Int) {
    fetchDetailProfileListCC(
      search: $search
      orgCode: $orgCode
      page: $page
      pageSize: $pageSize
    ) {
      empCode
      empName
      orgCode
      orgUnitCode
      positionName
      organiztionName
      division
      department
    }
  }
`;

const employeeDetailProfileForLeave = gql`
  query ($empCode: String!) {
    employeeDetailProfileForLeave(empCode: $empCode) {
      empCode
      empName
      orgCode
      orgUnitCode
      positionName
      organiztionName
      division
      department
      subDeptCode
      subDeptName
      childSubDeptCode
      childSubDeptName      
    }
  }
`;

const listCancelWaitingForApproval = gql`
  query ($search: String, $status: String) {
    listCancelWaitingForApproval(search: $search, status: $status) {
      docId
      empCode
      approverCode
      dropDownNameTh
      leaveCancelRequestId
      wdLeaveId
      createdAt
      leaveCancelRequestStatus
      docNo
      leaveStartDate
      leaveEndDate
      leaveTypeLabel
      leaveDay
      employeeName
      orgName
      division
      status
    }
  }
`;

const detailLeaveDocumentAsFlow = gql`
  query ($wdLeaveId: String) {
    detailLeaveDocumentAsFlow(wdLeaveId: $wdLeaveId) {
      leaveCancelRequestId
      wdLeaveId
      requestBy
      empCode
      approverCode
      leaveCancelRequestStatus
      leaveCancelRequestReason
      actionBy
      isAction
      actionAt
      createdBy
      createdAt
      updatedBy
      updatedAt
      isDelete
      clientType
    }
  }
`;

const fetchUrlSalaryCertForBank = gql`
  query ($profileKey: String, $empCode: String, $documentType: String) {
    fetchUrlSalaryCertForBank(
      profileKey: $profileKey
      empCode: $empCode
      documentType: $documentType
    ) {
      linkPDF
    }
  }
`;

const fetchDropDownMasterData = gql`
  query ($dropDownType: String!, $refCode: String) {
    fetchDropDownMasterData(dropDownType: $dropDownType, refCode: $refCode) {
      label
      id
      dropDownId
    }
  }
`;

const fetchConditionSalaryCertForBankText = gql`
  query ($profileKey: String) {
    fetchConditionSalaryCertForBankText(profileKey: $profileKey)
  }
`;

const dropDownMasterSlipPayment = gql`
  query(
    $docGroup: String!
    $type: Int!
  ){
   dropDownMasterSlipPayment(
      docGroup: $docGroup
      type: $type
   ){
      id
      label
   }
  }
`;


const fetchUrlTuitionFeesReport = gql`
  query (
    $studyEducationStatus: String
    $startApproveDate: String
    $endApproveDate: String  
  ) {
    fetchUrlTuitionFeesReport(
    studyEducationStatus: $studyEducationStatus
    startApproveDate: $startApproveDate
    endApproveDate: $endApproveDate
  ) {
      linkPDF
    }
  }
`;

export default {
  fetchListPost,
  fetchListPostType,
  fetchProfile,
  fetchProfileForLeave,
  fetchProfileDetail,
  fetchEmployeeProfile,
  fetchTimeAttendanceByDate,
  fetchSlip,
  fetchUrlSlip,
  fetchListContactUs,
  refreshToken,
  fetchListDocumen,
  fetchListDocumenList,
  verifyUser,
  fetchListOrganization,
  fetchEmployeeBankAccount,
  fetchEmployeeTax,
  fetchEmployeeCompensation,
  fetchListNotification,
  fetchPolicyLastVersion,
  verifyEmpCodeLogin,
  generateCaptcha,
  domainLists,
  accordingProfile,
  fetchCourse,
  fetchCourseList,
  fetchListOrganizationGroup,
  fetchEmployeeFamily,
  fetchEmployeeProvidentFund,
  howToOpenPayrollSlip,
  fetchUrlTax,
  checkRequestCaptcha,
  requestSendingOTP,
  sendVerifyCode,
  setupPassword,
  forgetPassword,
  checkSMSforgetPassword,
  resetPassword,
  requestProfileCheck,
  fetchListDocumentGroup,
  fetchListSystem,
  fetchListContactUsCategory,
  templateFormTax,
  fetchTaxDraft,
  fetchDetailTaxAll,
  guideLineTax,
  confirmTextTaxDraft,
  fetchListDropDownMasterData,
  fetchListDocumentCategoryMasterData,
  fetchListKCMHDocument,
  fetchListKCMHDocumentList,
  fetchListDropDownDivisionCDMasterData,
  fetchListKCMHQualityDocument,
  fetchListKCMHQualityDocumentList,
  fetchListDocumentTypeMasterData,
  dropdownListRelation,
  detchProfileListDetail,
  dropdownListTitleMale,
  dropdownListTitleFemale,
  fetchUrlConicleAllPolicy,
  fetchUrlConicleRequestPolicy,
  fetchUrlConicleMyPolicy,
  fetchEmployeeRights,
  fetchApplicationSetting,
  fetchCountAllNotification,
  fetchUrlTax6Month,
  dropdownListProvince,
  dropdownListAmphur,
  dropdownListDistrict,
  fetchSlipPayDate,
  fetchUrlTaxYears,
  dropDownSlipPayment,
  fetchNotification,
  fetchUrlConicleRedirectPath,
  fetchListWDHospital,
  fetchListSearchWDHospital,
  fetchMedicalExpensesLicensee,
  dropdownMedicalExpensesLicensee,
  fetchApproverMedical,
  dropdownListHospital,
  dropdownListSickness,
  fetchHospital,
  fetchOptionApprover,
  fetchListWDHospitalApprover,
  fetchListSearchWDHospitalApprover,
  fetchWDHospitalHistory,
  fetchLeaveDocumentList,
  dropdownLeaveType,
  fetchLeaveDay,
  fetchWorkingDay,
  fetchLeaveDocumentDetail,
  fetchLeaveDocumentDetailStatus,
  fetchListLeaveDocumentApprover,
  fetchLeaveDocumentHistory,
  fetchApproverLeave,
  fetchOptionApproverLeave,
  fetchEmployeeDetail,
  fetchEmployeeProfileHistory,
  fetchListChildTuitions,
  fetchListDelegateApprover,
  fetchListDelegator,
  fetchCountListAllApproving,
  checkIsEmployeeProfileHistoryActive,
  fetchLeaveDayAll,
  fetchSalaryCert,
  fetchUrlSalaryCert,
  fetchConditionSalaryCertText,
  fetchConditionSalaryCertForBankText,
  dropdownListHospitalBankAccount,
  fetchUrlWDHospitalApproverPDFReport,
  dropDownTypeSalaryCert,
  dropDownTypeSalaryCertForBank,
  redirectWDHospitalPath,
  fetchAllProvidentFundDetail,
  fetchConfigChangeProvPercentage,
  fetchFundChangeHistory,
  fetchFundChangeBenefitPersonDetail,
  dropdownRelationShipLabel,
  fetchListChildDetailInTuition,
  fetchEachChildTuitionDetail,
  fetchEmpwithCoA,
  fetchLeaveShiftTime,
  fetchLeaveHour,
  fetchLeaveDocumentDetailDraf,
  fetchTotalDayOff,
  fetchListStudyLeaveRequest,
  fetchMasterConfigTypeLeave,
  fetchStudyLeaveRequestById,
  dropDownstudyLeaveYear,
  fetchDetailProfileListCC,
  employeeDetailProfileForLeave,
  listCancelWaitingForApproval,
  detailLeaveDocumentAsFlow,
  fetchUrlSalaryCertForBank,
  fetchDropDownMasterData,
  dropDownMasterSlipPayment,
  fetchUrlTuitionFeesReport
};
